<div class="video-wrapper">
    <video muted autoplay #cameraPreview></video>
    <div class="video-overlay"></div>
</div>